module.exports = __webpack_public_path__ + "img/power-off.866d7de3.svg";